module.exports = __webpack_public_path__ + "static/media/icon-stats-down.be514b1f.svg";